import { fmtDate } from '../lib/dates.ts';
import type { ReactNode } from 'react';
import { HELP } from './helpContent.ts';

/**
 * The manual, on screen and on paper.
 *
 * Printing this page is the booklet. Keeping them the same document
 * is the point: a separate PDF is out of date the week after it is
 * written, and it is always the printed one nobody updates.
 */
export const Help = ({ name, brand, version }: {
  name: string;
  /** The same mark the header uses, so the booklet matches. */
  brand?: ReactNode;
  version?: string | null;
}) => (
  <div className="helpDoc">
    <header className="helpCover">
      {brand && <div className="helpLogo">{brand}</div>}
      <h1>{name}</h1>
      <p className="mono">Everyday guide</p>
      <p className="sub">
        Kestrelay{version ? ` \u00b7 app ${version}` : ''}
        {' \u00b7 '}
        {fmtDate(new Date().toISOString())}
      </p>
    </header>

    {HELP.map((s) => (
      <section key={s.id} className="helpSection">
        <h2>
          {s.title}
          {s.audience !== 'both' && (
            <span className="helpWho mono">
              {s.audience === 'site' ? 'at a site' : 'head office'}
            </span>
          )}
        </h2>
        <dl>
          {s.items.map((it) => (
            <div key={it.q} className="helpItem">
              <dt>{it.q}</dt>
              <dd>{it.a}</dd>
            </div>
          ))}
        </dl>
      </section>
    ))}

    {/* The booklet. Print rules keep a question with its answer
        and start each part on its own page. */}
    <a className="btnLink noPrint" href="/guide.pdf"
       target="_blank" rel="noreferrer">
      Download the full guide
    </a>

    <button className="noPrint" onClick={() => window.print()}>
      Print this guide
    </button>

    <p className="helpFoot sub">
      Something not covered here? Ask head office, or use Chat.
    </p>
  </div>
);
